var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgSurprise = function SvgSurprise(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.247 20.8883L8.60163 16.9202C8.28652 16.809 8.00446 16.6202 7.78144 16.3713C7.55842 16.1224 7.4016 15.8214 7.32541 15.496C7.24922 15.1707 7.25612 14.8313 7.34547 14.5093C7.43481 14.1873 7.60374 13.8929 7.83669 13.6533L14.5139 6.97606C14.7606 6.74488 15.0616 6.57971 15.3891 6.49587C15.7166 6.41204 16.06 6.41225 16.3874 6.49648C16.7148 6.58072 17.0156 6.74625 17.262 6.97773C17.5084 7.20922 17.6923 7.49916 17.7968 7.82068L21.749 18.466C21.8588 18.8109 21.8701 19.1796 21.7817 19.5306C21.6933 19.8815 21.5087 20.2009 21.2487 20.4526C20.9887 20.7044 20.6635 20.8785 20.3099 20.9555C19.9562 21.0325 19.5881 21.0092 19.247 20.8883V20.8883Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.62964 11.2151C4.33731 10.8202 5.16604 10.701 5.95632 10.8804",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.26286 6.67328C6.81158 5.99296 6.62455 5.17114 6.73697 4.36253",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9282 1C10.3697 2.71102 10.4432 4.56561 11.1354 6.22707",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.95623 5.87647C2.3963 5.87647 2.75304 5.51973 2.75304 5.07966C2.75304 4.6396 2.3963 4.28285 1.95623 4.28285C1.51617 4.28285 1.15942 4.6396 1.15942 5.07966C1.15942 5.51973 1.51617 5.87647 1.95623 5.87647Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgSurprise);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/surprise.3abb1729e73ef72e12e69eeea986ab87.svg";